import notify from '../../../shared/feedback/notifications';

import { Translate } from '../../../shared/LanguageService';
import { BookingType } from '../types/types';
import { getRedirectPathToOrder } from './redirectOrderFlow';

type CreatedOrderResult = {
    photoOrderId: number | null;
    digitalStylingOrderId: number | null;
    planOrderId: number | null;
};

type OrderCreatedHistory = {
    push: (path: string) => void;
};

export function handleOrderCreated(
    bookingType: BookingType,
    result: CreatedOrderResult,
    history: OrderCreatedHistory
): void {
    if (bookingType === BookingType.AdminBookableOrder) {
        const title = Translate('orders/create/booking-request-confirmation/title');
        const body = `${Translate('orders/create/booking-request-confirmation/body1')} ${Translate(
            'orders/create/booking-request-confirmation/body2'
        )}`;

        notify.success(`${title}: ${body}`);
    } else {
        notify.success(Translate('orders/notification/order-created'));
    }

    history.push(getRedirectPathToOrder(result));
}
